<template>


    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <div class="cf-dialog cf-dialog--xxl">
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-exchange-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{titlemodal}}</h4>
                            <p class="cf-modal-head__sub">Transferts / opérations de caisse</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>
                <div class="cf-dialog-body">



                    <div class="box  overflow-hidden">
                        <div class="box-header justify-between " style="display: block">



                            <div class="grid grid-cols-12  gap-x-6">


                                <div class=" xl:col-span-8  col-span-12 mt-4 mb-4">
                                    <input v-model="searchword" class="form-control form-control-lg w-full" type="text"
                                           placeholder="Rechercher"
                                           aria-label=".form-control-lg example">
                                </div>

                                <div class="xl:col-span-3  col-span-12 mt-4 mb-4"></div>


                                <div class="xl:col-span-1  col-span-12 mt-4 mb-4">
                                    <button @click="btnajouter" class="ti-btn ti-btn-primary-full !py-1 !px-2 !text-[0.75rem] w-full">
                                        <i class="ri-add-line  align-middle"></i>Ajouter
                                    </button>
                                </div>


                                <div class=" xl:col-span-2  col-span-12 mt-4 mb-4">

                                    <select v-model="DefaultperPage" style=" display: inline-block; margin: 0 5px; padding: 2px 25px;
                                            border: 1px solid #aaa; border-radius: 3px;" class="tabulator-page-size w-full"
                                            aria-label="Page Size" title="Affichage">
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="150">150</option>
                                        <option value="200">200</option>
                                        <option value="250">250</option>
                                        <option value="300">300</option>
                                    </select>
                                </div>

                            </div>


                        </div>


                        <div class="box-body !p-0 mybodyheight300px">
                            <div class="table-responsive">

                                <!-- component -->
                                <div class="flex flex-col h-screen">
                                    <div class="flex-grow overflow-auto">

                                        <table class="relative w-full border table mytable table-hover whitespace-nowrap min-w-full">
                                            <thead>

                                            <tr>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">N°</th>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">N° document</th>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">Date</th>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">Motif / Raison</th>

                                                <template v-if="typedoc==='BOR'">

                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th
                                                    text-start">Charge</th>

                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th
                                                    text-start">N° bordereau</th>

                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th
                                                    text-start">Bénéficiaire / déposant</th>

                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th
                                                    text-start">N° chèque</th>
                                                </template>


                                                <template v-if="typedoc==='BOR' || typedoc==='OPB'">

                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th
                                                    text-start">Banque</th>

                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th
                                                    text-start">Type d'opération</th>

                                                </template>


                                                <template v-if="typedoc==='DPC'">

                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th
                                                    text-start">Caisse débiteur</th>

                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th
                                                    text-start">Caisse créditeur</th>

                                                </template>


                                                <template v-if="typedoc==='APPRO' || typedoc==='DPB'">

                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th
                                                    text-start">Banque</th>

                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th
                                                    text-start">Caisse</th>

                                                </template>


                                                <template v-if="typedoc==='APPROC'">

                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th
                                                    text-start">Caisse créditeur</th>

                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th
                                                    text-start">Caisse débiteur</th>

                                                </template>

                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">Montant</th>
                                                <template v-if="typedoc==='APPROC' || typedoc==='DPC'">

                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th
                                                    text-start">Etat du transfert</th>

                                                </template>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">Créer le</th>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">Action</th>

                                            </tr>
                                            </thead>
                                            <tbody>

                                            <template v-if="filterdatatable.length">




                                                <tr  class="border-t hover:bg-gray-200 dark:hover:bg-light" v-for="(datavalue,index) in filterdatatable" :key="index">

                                                    <td  data-label="N°Document  : "   >{{ parseFloat(index)+1 }}</td>
                                                    <td  data-label="N°Document  : "   >{{ datavalue.numdoc }}</td>
                                                    <td  data-label="Date  : "   >{{ datavalue.dateop }}</td>
                                                    <td  data-label="Motif / Raison : " >{{ datavalue.bmotif }}</td>
                                                    <template v-if="typedoc==='DPC'">
                                                        <td  data-label="Caisse débiteur : " >{{ datavalue.caissedebiteur }}</td>
                                                        <td  data-label="Caisse créditeur : " >{{ datavalue.caissecrediteur }}</td>
                                                        <td data-label="Montant : " >{{  formatNumber(datavalue.montant) }}</td>
                                                        <template v-if="datavalue.etatdelatransaction===0">
                                                            <td data-label="Etat du transfert : " >
                                                                <div class="alert alert-danger" role="alert">
                                                                    Transaction en cours de validation
                                                                </div>
                                                            </td>
                                                        </template>
                                                        <template v-if="datavalue.etatdelatransaction===1">
                                                            <td data-label="Etat du transfert : " >
                                                                <div class="alert alert-success" role="alert">
                                                                    Transaction validée
                                                                </div>
                                                            </td>
                                                        </template>
                                                        <template v-if="datavalue.etatdelatransaction===2">
                                                            <td data-label="Etat du transfert : " >
                                                                <div class="alert alert-danger" role="alert">
                                                                    Transaction annulée
                                                                </div>
                                                            </td>
                                                        </template>

                                                    </template>
                                                    <template v-if="typedoc==='APPROC'">
                                                        <td  data-label="Caisse créditeur : " >{{ datavalue.caissecrediteur }}</td>
                                                        <td  data-label="Caisse débiteur : " >{{ datavalue.caissedebiteur }}</td>
                                                        <td data-label="Montant : " >{{  formatNumber(datavalue.montant) }}</td>

                                                        <template v-if="datavalue.etatdelatransaction===0">
                                                            <td data-label="Etat du transfert : " >
                                                                <div class="alert alert-danger" role="alert">
                                                                    Transaction en cours de validation
                                                                </div>
                                                            </td>
                                                        </template>
                                                        <template v-if="datavalue.etatdelatransaction===1">
                                                            <td data-label="Etat du transfert : " >
                                                                <div class="alert alert-success" role="alert">
                                                                    Transaction validée
                                                                </div>
                                                            </td>
                                                        </template>
                                                        <template v-if="datavalue.etatdelatransaction===2">
                                                            <td data-label="Etat du transfert : " >
                                                                <div class="alert alert-danger" role="alert">
                                                                    Transaction annulée
                                                                </div>
                                                            </td>
                                                        </template>



                                                    </template>
                                                    <template v-if="typedoc==='BOR'">
                                                        <td  data-label="Charge : " >{{ datavalue.charge }}</td>
                                                        <td  data-label="N° bordereau : " >{{ datavalue.numbordereau }}</td>
                                                        <td  data-label="Bénéficiaire / déposant: " >{{ datavalue.deposantname }}</td>
                                                        <td  data-label="N° chèque : " >{{ datavalue.numcheque }}</td>
                                                    </template>
                                                    <template v-if="typedoc==='OPB' ||
                                                typedoc==='BOR'">
                                                        <td  data-label="Banque : " >{{ datavalue.banque }}</td>
                                                        <td  data-label="Type d'opération : " >{{ datavalue.typeoperation }}</td>
                                                        <td data-label="Montant : " >{{  formatNumber(datavalue.montant) }}</td>
                                                    </template>
                                                    <template v-if="typedoc==='APPRO' ||
                                                typedoc==='DPB'">
                                                        <td  data-label="Banque : " >{{ datavalue.banque }}</td>
                                                        <td  data-label="Caisse : " >{{ datavalue.caisse }}</td>
                                                        <td data-label="Montant : " >{{ formatNumber(datavalue.montant)  }}</td>
                                                    </template>

                                                    <td  data-label="Créer le  : "   >{{ datavalue.creerler }}</td>

                                                    <td  data-label="Action  : "   >

                                                        <div class="cf-actions">
                                                            <button v-if="typedoc==='DPC' || typedoc==='APPROC'" @click="ouvrirdocument(datavalue)" class="cf-iconbtn cf-iconbtn--primary" title="Ouvrir"><i class="ri-folder-open-fill"></i></button>
                                                            <button v-if="(typedoc==='DPC' || typedoc==='APPROC') && datavalue.etatdelatransaction===0" @click="btnsuppression(datavalue)" class="cf-iconbtn cf-iconbtn--danger" title="Annuler"><i class="ri-close-circle-line"></i></button>
                                                        </div>




                                                    </td>

                                                </tr>



                                            </template>


                                            <template v-else>
                                                <tr >
                                                    <td colspan="20"><div class="alert alert-danger text-center">Aucun enregistrement n'a été trouvé.</div></td>
                                                </tr>

                                            </template>



                                            </tbody>
                                        </table>


                                    </div>
                                </div>

                            </div>
                        </div>


                        <div class="flex flex-col box-footer border-t-0 ">
                            <div class="flex items-center flex-wrap overflow-auto">
                                <div class="mb-2 sm:mb-0">

                                </div>
                                <div class="ms-auto">


                                    <nav aria-label="Page navigation">
                                        <ul class="ti-pagination mb-0">
                                            <li class="page-item">
                                                <button :class="{ 'disabled': page <= 1 }" class="page-link px-3 py-[0.375rem]" @click="page--">Previous</button>
                                            </li>
                                            <li class="page-item">
                                                <button class="page-link px-3 py-[0.375rem]" :class="{ 'active': pageNumber === page }"
                                                        :key="key" v-for="(pageNumber, key) in displayedPages" @click="page = pageNumber">
                                                    {{ pageNumber }}
                                                </button>
                                            </li>
                                            <li class="page-item">
                                                <button :class="{ 'disabled': page >= pages.length }" class="page-link px-3 py-[0.375rem]" @click="page++">Next</button>
                                            </li>
                                        </ul>
                                    </nav>





                                </div>
                            </div>
                        </div>
                    </div>






                </div>
                <div class="cf-dialog-foot">
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>
            </div>
        </div>
    </Transition>

    <modalform ref="modalform"  @closed="load"></modalform>
    <modalformsuppression @closed="load"  ref="modalformsuppression"></modalformsuppression>
    <modalrapportdeprefdpcc ref="modalrapportdeprefdpcc" ></modalrapportdeprefdpcc>
    <formouvrirdoc ref="formouvrirdoc" ></formouvrirdoc>


</template>

<script>


    import modalrapportdeprefdpcc from "@/components/views/pages/caisse/rapport/modal_rapport_dep_ref_dpcc";

    const axios =require('axios');

    import modalform from "@/components/views/pages/caisse/transfertdefonddecaisse/form";
    import modalformsuppression from "@/components/views/pages/caisse/transfertdefonddecaisse/annulervalidationouinon";
    import formouvrirdoc from "@/components/views/pages/caisse/transfertdefonddecaisse/formouvrirdoc";


    import {currencyFormatDE,  randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },


        },
        computed:{

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){

                let mvalue=this.datatable;

                this.perPage=this.DefaultperPage;

                /*  if (this.searchword!==''){
                      let t=this;


                      mvalue = mvalue.filter( function (post) {
                          return
                         post.namefournisseur.toLowerCase().includes(t.searchword.toLowerCase())

                      })

                  }

                  this.totalmontant=0;
                  this.totalmontantrestant=0;
                  let t=this;
                  mvalue.forEach(function (items) {
                      t.totalmontant=parseInt(t.totalmontant)+parseInt(items.montantbcd);
                      t.totalmontantrestant=parseInt(t.totalmontantrestant)+parseInt(items.montantbcdtrt);
                  })*/




                return this.paginate(mvalue) ;
            },
        },
        components: {
            modalform,
            modalformsuppression,
            formouvrirdoc,
            modalrapportdeprefdpcc

        },

        data() {
            return {
                isdisplay:false,
                mname:"",
                titlemodal:"",
                titleca:"",
                titlecp:"",
                datatable:[],
                otherdatatable:[],
                listedupersonnel:[],
                datainputlibelleforms:[],
                datatiers:[],
                typedoc:"",
                messageerror:"",
                messagesucces:"",
                vtypc:"",

                totalmontant:0,
                totalmontantrestant:0,

                searchword:"",
                searchtrierletableau:"",

                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 50,
                Defaultpage: 1,
                DefaultperPage: 50,
                pages: [],
            };
        },
        methods: {

            formatNumber(num) {

                return  currencyFormatDE(num)
            },

            btnajouter(){

                let Item={
                    pid:'',
                    datedoc:this.$store.state.dateouverturecaisse,
                    motif:'',
                    docnum:'',
                    ca:null,
                    cp:null,
                    montant:0,
                }

                this.$refs.modalform.show(this.mname,"add",this.typedoc,Item,this.titleca,this.titlecp,this.vtypc,this.otherdatatable);

            },


            ouvrir_viacompteclient(value,typereglement){

                let authoriationplslignedepense=0

                let mname

                let  Item= {
                    solde:value.solde,
                    pid:value.pid,
                    numreglement:'',
                    numfacture:value.numdoc,
                    namecltfrs:value.namecltfrs,
                    mtntotal:value.montanttotal,
                    mtntrestantapayer:value.montantrestant,
                    mtntrestantapayertrt:value.montantrestant,
                    montant:0,
                    datedoc:this.$store.state.dateouverturecaisse,
                    docobservation:'',
                    docnum:'',
                    deposantname:'',
                    numcheque:'',
                    reglepar:'Caisse',
                    modereglement:null,
                    reglementbanque:null,
                    reglementcaisse:null,
                    params:null,
                    avance:null,
                }


                mname='Régler le document '+value.numdoc;

                this.$refs.modalform.show(mname,"add",this.typedoc,Item,this.otherdatatable,typereglement);

            },


            btnsuppression(value){

                if (value.etatdelatransaction===1 || value.etatdelatransaction==='1'){

                    toastr['error']( "Impossible d'annuler cette ligne. Veuillez contacter votre administrateur. ","<b></b>");
                    return
                }


                let titlemodal="VOULLEZ-VOUS VRAIMENT ANNULER LE DOCUMENT "+value.numdoc+" ?";


                value.typligne="A"+this.typedoc

                this.$refs.modalformsuppression.show(titlemodal,value,this.typedoc);

            },



            ouvrirdocument(value){

                let mname

                let  Item= value


                this.$refs.formouvrirdoc.show(mname,Item,this.titleca,this.titlecp);

            },


            async load(){

                var caisse={
                    cf:this.$store.state.caisseinfo,
                    document:this.typedoc,
                    vtypc:this.vtypc
                }


                this.$store.dispatch('lancerchargement',true)
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/doc/caisse/fkdfkdozojdj_refdepdpcc/'+this.$store.state.appsociete+'/895418init51_refdepdpcc11515/'+randomString();
                let response =   axios  .post(url,caisse,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)

                        if(res.data.success){

                            t.datatable=[];
                            t.datatable=res.data.m.datas;
                            /*t.cp=res.data.m.cp;
                            t.ca=res.data.m.ca;*/
                            t.otherdatatable={
                                cp:res.data.m.cp,
                                ca:res.data.m.ca,
                            }
                            t.isdisplay=true;
                        }
                        else{
                            t.datatable=[];

                            t.otherdatatable={
                                cp:[],
                                ca:[],
                            }
                            t.isdisplay=true;

                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })




            },

            async loadreturnotherdata(){

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl745874pdefinition771714dfe/caisse/othetdskd8755dsdhisd/other222dksdk/'+this.typedoc+'/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){
                            t.otherdatatable=[];
                            t.otherdatatable=res.data.otherdata;
                        }
                        else{
                            t.otherdatatable=[];

                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })
                //  }



            },


            /*
                        btnmodifier(value){


                            let titlemodal="Modifier l'enregistrement "+value.name

                            let Item={
                                pid:value.pid,intitule:value.name,typ:value.typetbfichier,taux:value.taux,
                                typreg:value.code,qteengros:value.qteengros,qteendetail:value.qteendetail
                            }

                            this.$refs.modalform.show(titlemodal,"update",value.typetbfichier,Item);

                        },

                        btnimprimer(value){

                            let t=this

                            if (t.typedoc==='DPCC' || t.typedoc==='REF'){
                                value.alldepense.push({motif:value.docobservation, montant:value.montant});
                            }


                            let tabvalue={
                                numdoc:value.numdoc,
                                date:value.dateop,
                                montanttotal:value.montant,
                                montanttotaldelafacure:value.montant,
                                items:value.alldepense,
                                docsaisiepar:value.saisirpar,
                                benrficiaire:value.beneficiaire,
                                qrr:value.docnum,
                                patient:value.beneficiaire.name,
                                observations:value.motif,
                                typdoc:t.typedoc


                            }



                            this.$refs.modalrapportdeprefdpcc.show(tabvalue);


                        },
            */


            close(){

                this.isdisplay=false;

                this.$emit('closed');

            },


            show(titlemodal,typedoc,vtypc){


                if(this.$store.state.caisseencour==='' ||
                    this.$store.state.caisseencour===''){

                    toastr['error']( "Veuillez sélectionner une caisse valide.")
                    this.$router.push({ name: 'tcaisse' });
                }
                else{

                    this.messagesucces="";
                    this.messageerror="";
                    this.titlemodal=titlemodal
                    this.typedoc=typedoc
                    this.vtypc=vtypc

                    if (this.typedoc==="DPC"){

                        this.titlemodal="Liste des transferts de fonds de caisse auxilliaire"
                        this.mname=" Enregistrer un transfert de fond de caisse auxilliaire"

                        this.titleca="Caisse auxilliaire"
                        this.titlecp="Caisse principale"

                    }

                    if (this.typedoc==="APPROC"){

                        this.titlemodal="Liste des transferts de fonds caisse principale"
                        this.mname=" Enregistrer un transfert de fond caisse principale"

                        this.titleca="Caisse principale / auxilliaire"
                        this.titlecp="Caisse principale"

                    }

                    if (this.typedoc==="BOR"){

                        this.titlemodal="Liste des bordereaux de banque enregistrés"
                        this.mname=" Enregistrer un bordereaux de banque"
                    }

                    if (this.typedoc==="OPB"){

                        this.titlemodal="Liste des opérations bancaires"
                        this.mname=" Enregistrer une operation bancaire"

                    }


                    if (this.typedoc==="APPRO"){

                        this.titlemodal="Liste des approvisionnements caisse par la banque"
                        this.mname=" Enregistrer un approvisionnements caisse par la banque"

                        this.titleca="Caisse principale"
                        this.titlecp="Banque"


                    }

                    if (this.typedoc==="DPB"){

                        this.titlemodal="Liste des dépôts en banque"
                        this.mname=" Enregistrer un dépôt en banque"


                        this.titleca="Caisse principale"
                        this.titlecp="Banque"


                    }




                    //this.isdisplay=true;

                    // this.loadinputlibelleforms()
                    // this.loadreturnotherdata()
                    this.load()


                }

            },






            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1200px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-th { background:var(--cf-surface-alt)!important; color:var(--cf-ink)!important; font-weight:600; font-size:0.75rem; letter-spacing:0.02em; }
.cf-actions { display:inline-flex; align-items:center; gap:4px; }
.cf-iconbtn { height:2rem; width:2rem; display:inline-flex; align-items:center; justify-content:center; border:none; border-radius:var(--cf-radius-sm); cursor:pointer; font-size:1rem; transition:all 0.15s; background:var(--cf-surface-alt); color:var(--cf-muted); }
.cf-iconbtn--primary:hover { background:rgb(var(--primary) / 0.12); color:rgb(var(--primary)); }
.cf-iconbtn--danger:hover { background:rgb(var(--danger) / 0.12); color:rgb(var(--danger)); }
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }

    .table td {
        cursor: pointer;
    }

    .h-screen{

        height: 300px!important;

    }

    .mybodyheight200px{
        height: 200px;
    }

    .mybodyheight300px{
        height: 300px;
    }

    .mybodyheight400px{
        height: 400px;
    }

    .mybodyheight500px{
        height: 500px;
    }

    @media screen and (max-width: 768px) {

        .cf-dialog--xxl{
            max-width: 100%!important;
        }


        .h-screen,.mybodyheight200px,.mybodyheight300px, .mybodyheight400px,.mybodyheight500px{
            height: 100%!important;
        }


    }

</style>